import { decodeHtml } from '@src/utils/decode'
import * as React from 'react'
import styled from 'styled-components'
import TextHighlight from './TextHighlight'

const Heading = styled.div`
  font-size: 12px;
  text-align: left;
`

const TooltipContents: React.FunctionComponent<{
  matched: string
  tooltipText: string
}> = ({ matched, tooltipText }) => (
  <div>
    <Heading>{decodeHtml(tooltipText)}</Heading>
    <TextHighlight matched={matched} />
  </div>
)

export default TooltipContents



// WEBPACK FOOTER //
// ./src/components/Modals/PlagiarismSourcesModal/TooltipContents.tsx